/**
 * Normalise HTML entity encoding in Unlayer-exported href attributes.
 *
 * Unlayer is inconsistent: button hrefs double-encode quotes (" → &quot; → &amp;quot;),
 * while text link hrefs leave quotes completely unencoded (raw "). Both land in a broken
 * state for extraction. This function normalises both to &quot; inside {{#jwt}} blocks so
 * the HTML is well-formed and the extraction regex doesn't need special handling.
 */
export function fixUnlayerHtmlEntities(html: string): string {
  // The outer regex handles href values that may contain raw " inside {{#jwt}} blocks
  // (text links). Outside JWT blocks, " terminates the attribute as normal.
  return html.replace(
    /href="((?:(?!{{#jwt}})[^"]|{{#jwt}}[\s\S]*?{{\/jwt}})*)"/g,
    (match, hrefValue: string) => {
      const fixed = hrefValue.replace(
        /{{#jwt}}([\s\S]*?){{\/jwt}}/g,
        (_jwtMatch, payload: string) => {
          const normalised = payload
            .replace(/&amp;quot;/g, '"') // decode double-encoded (Unlayer button bug)
            .replace(/"/g, "&quot;"); // encode raw quotes (Unlayer text link bug)
          return `{{#jwt}}${normalised}{{/jwt}}`;
        },
      );
      if (fixed === hrefValue) return match;
      return `href="${fixed}"`;
    },
  );
}
